import config from "@/app.config";
import { getMessage } from "@/lib/error";
import axios from "axios";
import { create } from "zustand";

type Props = {
  open: boolean;
  loading: boolean;
  error: string;
  payload: {
    name: string;
    email: string;
    phone: string;
  };
  variantId: string;
  setPayload: (key: string, value: string) => void;
  setOpen: (value: string) => void;
  cancel: () => void;
  submit: () => Promise<{ error: boolean; message: string }>;
};

const useUnavailableProduct = create<Props>((set, get) => ({
  open: false,
  loading: false,
  error: "",
  payload: {
    name: "",
    email: "",
    phone: "",
  },
  variantId: "",
  setPayload: (key, value) => {
    const { payload } = get();

    set({ payload: { ...payload, [key]: value } });
  },
  setOpen: (value) => set(() => ({ open: true, variantId: value })),
  cancel: () => {
    set(() => ({
      open: false,
      variantId: "",
      error: "",
      payload: {
        name: "",
        email: "",
        phone: "",
      },
    }));
  },
  submit: async () => {
    const { variantId, payload, cancel } = get();

    try {
      set(() => ({ loading: true }));

      await axios.post(
        `${config.app.apiBaseUrl}/api/v2/unavailable-product-notify`,
        {
          variant_id: variantId,
          ...payload,
        },
      );

      cancel();

      return {
        error: false,
        message: "We'll notify you when the product is back in stock.",
      };
    } catch (error: unknown) {
      return {
        error: true,
        message: getMessage(error),
      };
    } finally {
      set(() => ({ loading: false }));
    }
  },
}));

export default useUnavailableProduct;
